<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BillingRules"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <ItpBox>
      <ItpButton
        variant="light"
        icon="fa-sync-alt"
        :tooltip="'Reload'|gettext"
        :spinning="actions.reload.isRunning"
        :text="'Reload'|gettext"
        class="ml-3"
        @click.prevent.stop="evh_6466705138206980_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="lets-icons:import"
        :text="'Import'|pgettext('Templates')"
        variant="light"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="lets-icons:export"
        :text="'Export'|pgettext('BillingRules')"
        variant="light"
        :disabled="!items || !items.length"
        use-auth
        force-download
        downloadFileName="billing-rules.json"
        :href="$fn.urlFor('export_object_by_type', {object_type: 'billing-rule'})"
        class="ml-3"
      >
      </ItpButton>
    </ItpBox>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <b-list-group
      v-if="(items && items.length) || createItem"
      :style="b_1040167445267876_style"
    >
      <b-list-group-item
        :key="item.id"
        v-if="items && items.length"
        v-for="item in items"
      >
        <ItpBox
          alignItems="start"
        >
          <BillingRule
            :item="item"
            :editing="editingItemID == item.id"
            class="flex-grow-1"
            @saved="evh_5731695935601903_saved($event, {item})"
            @cancelEdit="evh_5731695935601903_cancelEdit($event, {item})"
          >
          </BillingRule>
          <DIV
            class="ml-3"
            :style="b_1747314907724257_style"
          >
            <b-dropdown
              size="sm"
              toggle-class="btn-default-borderless"
              no-caret
              variant="none"
            >
              <ItpIcon
                fa="ellipsis-v"
                class="mx-1"
                slot="button-content"
              >
              </ItpIcon>
              <b-dropdown-item-button
                @click.prevent.stop="evh_4196617261796474_clickPreventStop($event, {item})"
              >
                <ItpText
                  :text="'Edit'|pgettext('Command')"
                >
                </ItpText>
              </b-dropdown-item-button>
              <b-dropdown-item-button
                @click.prevent.stop="evh_261555069697365_clickPreventStop($event, {item})"
              >
                <ItpText
                  :text="'Delete'|pgettext('Command')"
                >
                </ItpText>
              </b-dropdown-item-button>
            </b-dropdown>
          </DIV>
        </ItpBox>
      </b-list-group-item>
      <BListGroupItem
        v-if="createItem"
      >
        <ItpBox
          alignItems="start"
        >
          <BillingRule
            editing
            class="flex-grow-1"
            @saved="evh_2272469684735879_saved($event, {})"
            @cancelEdit="evh_2272469684735879_cancelEdit($event, {})"
          >
          </BillingRule>
          <DIV
            class="ml-3"
            :style="b_8363486085232621_style"
          >
             
          </DIV>
        </ItpBox>
      </BListGroupItem>
      <BListGroupItem
        class="border-0"
        v-if="!createItem"
      >
        <ItpBox
          justifyContent="center"
        >
          <ItpButton
            variant="primary"
            :text="'Create rule'|pgettext('BillingRules')"
            :disabled="editingItemID != null"
            class="w-auto"
            @click.prevent.stop="evh_3373384577795494_clickPreventStop($event, {})"
          >
          </ItpButton>
        </ItpBox>
      </BListGroupItem>
    </b-list-group>
    <ItpBox
      direction="column"
      alignItems="center"
      justifyContent="center"
      v-if="(!items || !items.length) && !createItem"
      :style="b_4186377094414664_style"
    >
      <p>
        {{ 'No rules have been defined yet.'|pgettext('BillingRules') }}
      </p>
      <ItpButton
        variant="primary"
        :text="'Create rule'|pgettext('BillingRules')"
        @click.prevent.stop="evh_3601807637515735_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      class="ml-auto"
    >
      <ItpButton
        :text="'Close'|gettext"
        variant="default"
        @click.prevent.stop="evh_2140198529698299_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingRules extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getContainer(...args: any[]) {
    return {
      self: this.$fn.urlFor('create_object_by_type'),
      object: 'list',
      data: []
    }
  }

  getPayload(...args: any[]) {
    const [editor] = args;
    const exclude = [];

    return editor.isNew ?
      editor.getData({ exclude }) :
      editor.getChanges({ exclude, skipEmbeddedLists: true })
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'billing-rule' }, asResource: true })
  }

  selectedItem!: any;

  async $$load_selectedItem() {
    return this.items.length ? this.items[0] : null
  }

  createItem!: any;
  editingItemID!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_1040167445267876_style!: any;
  b_1747314907724257_style!: any;
  b_8363486085232621_style!: any;
  b_4186377094414664_style!: any;
  dataMembers = ['formId', 'formName', 'items', 'selectedItem', 'createItem', 'editingItemID', 'ux', 'b_7315092382398562_modalBindings', 'b_1040167445267876_style', 'b_1747314907724257_style', 'b_8363486085232621_style', 'b_4186377094414664_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "billingListItem",
        items: null,
        selectedItem: null,
        createItem: false,
        editingItemID: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_1040167445267876_style: {
          minHeight: "300px",
        }
        ,
        b_1747314907724257_style: {
          minWidth: "20px",
        }
        ,
        b_8363486085232621_style: {
          minWidth: "20px",
        }
        ,
        b_4186377094414664_style: {
          minHeight: "300px",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("BillingRules|Title", "Billing Rules")
          ,
        '(' + (this.items ? this.items.length : 0) + ')'
          ,
        ]
        ,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2362_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2362, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_6466705138206980_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_showModal_2368_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_2368, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.$fn.urlFor('import_object_by_type', { object_type: 'billing-rule' }),
        accept: ".json",
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_5731695935601903_script_2372_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5731695935601903_script_2372, alias=undefined
    (this.setData('createItem', null), this.setData('editingItemID', null))
  }

  async act_5731695935601903_script_2372_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5731695935601903_script_2372, alias=undefined
    return {
      value: () => this.act_5731695935601903_script_2372_getActionArgs_value($event),
    }
  }

  async evh_5731695935601903_saved(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5731695935601903_saved.executeFromDOM(this, event, scope);
  }

  async act_5731695935601903_script_2376_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5731695935601903_script_2376, alias=undefined
    (this.setData('createItem', null), this.setData('editingItemID', null))
  }

  async act_5731695935601903_script_2376_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5731695935601903_script_2376, alias=undefined
    return {
      value: () => this.act_5731695935601903_script_2376_getActionArgs_value($event),
    }
  }

  async evh_5731695935601903_cancelEdit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5731695935601903_cancelEdit.executeFromDOM(this, event, scope);
  }

  async act_4196617261796474_script_2378_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4196617261796474_script_2378, alias=editItem
    this.editingItemID = $event.scope.item.id
  }

  async act_4196617261796474_script_2378_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4196617261796474_script_2378, alias=editItem
    return {
      value: () => this.act_4196617261796474_script_2378_getActionArgs_value($event),
    }
  }

  async evh_4196617261796474_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4196617261796474_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_261555069697365_rest_2380_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_261555069697365_rest_2380, alias=deleteItem
    return {
      method: "delete",
      resource: $event.scope.item,
    }
  }

  async evh_261555069697365_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_261555069697365_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2272469684735879_script_2384_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2272469684735879_script_2384, alias=undefined
    (this.setData('createItem', null), this.setData('editingItemID', null))
  }

  async act_2272469684735879_script_2384_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2272469684735879_script_2384, alias=undefined
    return {
      value: () => this.act_2272469684735879_script_2384_getActionArgs_value($event),
    }
  }

  async evh_2272469684735879_saved(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2272469684735879_saved.executeFromDOM(this, event, scope);
  }

  async act_2272469684735879_script_2388_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2272469684735879_script_2388, alias=undefined
    (this.setData('createItem', null), this.setData('editingItemID', null))
  }

  async act_2272469684735879_script_2388_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2272469684735879_script_2388, alias=undefined
    return {
      value: () => this.act_2272469684735879_script_2388_getActionArgs_value($event),
    }
  }

  async evh_2272469684735879_cancelEdit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2272469684735879_cancelEdit.executeFromDOM(this, event, scope);
  }

  async act_3373384577795494_script_2390_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3373384577795494_script_2390, alias=createRule
    this.createItem = true
  }

  async act_3373384577795494_script_2390_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3373384577795494_script_2390, alias=createRule
    return {
      value: () => this.act_3373384577795494_script_2390_getActionArgs_value($event),
    }
  }

  async evh_3373384577795494_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3373384577795494_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3601807637515735_script_2392_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3601807637515735_script_2392, alias=createRule
    this.createItem = true
  }

  async act_3601807637515735_script_2392_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3601807637515735_script_2392, alias=createRule
    return {
      value: () => this.act_3601807637515735_script_2392_getActionArgs_value($event),
    }
  }

  async evh_3601807637515735_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_2140198529698299_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2362: actions.CloseModalAction;
    evh_7315092382398562_close_2361: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2364: actions.CloseModalAction;
    evh_2248226175642056_close_2363: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_6466705138206980_reloadComponentData_2366: actions.ReloadComponentDataAction;
    evh_6466705138206980_clickPreventStop_2365: actions.EventHandlerImpl;
    evh_6466705138206980_clickPreventStop: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_2370: actions.ReloadComponentDataAction;
    evh_8320016629450276_close_2369: actions.EventHandlerImpl;
    act_8320016629450276_showModal_2368: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_2367: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_5731695935601903_script_2372: actions.ScriptAction;
    evh_5731695935601903_saved_2371: actions.EventHandlerImpl;
    act_5731695935601903_reloadComponentData_2374: actions.ReloadComponentDataAction;
    evh_5731695935601903_saved_2373: actions.EventHandlerImpl;
    evh_5731695935601903_saved: actions.EventHandlerGroup;
    act_5731695935601903_script_2376: actions.ScriptAction;
    evh_5731695935601903_cancelEdit_2375: actions.EventHandlerImpl;
    evh_5731695935601903_cancelEdit: actions.EventHandlerGroup;
    act_4196617261796474_script_2378: actions.ScriptAction;
    evh_4196617261796474_clickPreventStop_2377: actions.EventHandlerImpl;
    evh_4196617261796474_clickPreventStop: actions.EventHandlerGroup;
    act_261555069697365_reloadComponentData_2382: actions.ReloadComponentDataAction;
    evh_261555069697365_deleted_2381: actions.EventHandlerImpl;
    act_261555069697365_rest_2380: actions.RestAction;
    evh_261555069697365_clickPreventStop_2379: actions.EventHandlerImpl;
    evh_261555069697365_clickPreventStop: actions.EventHandlerGroup;
    act_2272469684735879_script_2384: actions.ScriptAction;
    evh_2272469684735879_saved_2383: actions.EventHandlerImpl;
    act_2272469684735879_reloadComponentData_2386: actions.ReloadComponentDataAction;
    evh_2272469684735879_saved_2385: actions.EventHandlerImpl;
    evh_2272469684735879_saved: actions.EventHandlerGroup;
    act_2272469684735879_script_2388: actions.ScriptAction;
    evh_2272469684735879_cancelEdit_2387: actions.EventHandlerImpl;
    evh_2272469684735879_cancelEdit: actions.EventHandlerGroup;
    act_3373384577795494_script_2390: actions.ScriptAction;
    evh_3373384577795494_clickPreventStop_2389: actions.EventHandlerImpl;
    evh_3373384577795494_clickPreventStop: actions.EventHandlerGroup;
    act_3601807637515735_script_2392: actions.ScriptAction;
    evh_3601807637515735_clickPreventStop_2391: actions.EventHandlerImpl;
    evh_3601807637515735_clickPreventStop: actions.EventHandlerGroup;
    act_2140198529698299_closeComponent_2394: actions.CloseComponentAction;
    evh_2140198529698299_clickPreventStop_2393: actions.EventHandlerImpl;
    evh_2140198529698299_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2362 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2362_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2361 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2362,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2361],
      }
    );
    const act_2248226175642056_closeModal_2364 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2363 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2364,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2363],
      }
    );
    const act_6466705138206980_reloadComponentData_2366 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_6466705138206980_clickPreventStop_2365 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_reloadComponentData_2366,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_6466705138206980_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_clickPreventStop_2365],
      }
    );
    const act_8320016629450276_reloadComponentData_2370 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8320016629450276_close_2369 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_2370,
        event: "close",
        displayName: "reloadComponentData",
      }
    );
    const act_8320016629450276_showModal_2368 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_2368_getActionArgs,
        events: [evh_8320016629450276_close_2369],
      }
    );
    const evh_8320016629450276_clickPreventStop_2367 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_2368,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_2367],
      }
    );
    const act_5731695935601903_script_2372 = new actions.ScriptAction(
      {
        actionArgs: this.act_5731695935601903_script_2372_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_saved_2371 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_script_2372,
        event: "saved",
        displayName: "script",
      }
    );
    const act_5731695935601903_reloadComponentData_2374 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5731695935601903_saved_2373 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_reloadComponentData_2374,
        event: "saved",
        displayName: "reloadComponentData",
      }
    );
    const evh_5731695935601903_saved = new actions.EventHandlerGroup(
      {
        handlers: [evh_5731695935601903_saved_2371, evh_5731695935601903_saved_2373],
      }
    );
    const act_5731695935601903_script_2376 = new actions.ScriptAction(
      {
        actionArgs: this.act_5731695935601903_script_2376_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_cancelEdit_2375 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_script_2376,
        event: "cancelEdit",
        displayName: "script",
      }
    );
    const evh_5731695935601903_cancelEdit = new actions.EventHandlerGroup(
      {
        handlers: [evh_5731695935601903_cancelEdit_2375],
      }
    );
    const act_4196617261796474_script_2378 = new actions.ScriptAction(
      {
        actionArgs: this.act_4196617261796474_script_2378_getActionArgs,
        displayName: "editItem",
        events: [],
      }
    );
    const evh_4196617261796474_clickPreventStop_2377 = new actions.EventHandlerImpl(
      {
        action: act_4196617261796474_script_2378,
        event: "click.prevent.stop",
        displayName: "editItem",
      }
    );
    const evh_4196617261796474_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4196617261796474_clickPreventStop_2377],
      }
    );
    const act_261555069697365_reloadComponentData_2382 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_261555069697365_deleted_2381 = new actions.EventHandlerImpl(
      {
        action: act_261555069697365_reloadComponentData_2382,
        event: "deleted",
        displayName: "reloadComponentData",
      }
    );
    const act_261555069697365_rest_2380 = new actions.RestAction(
      {
        actionArgs: this.act_261555069697365_rest_2380_getActionArgs,
        displayName: "deleteItem",
        events: [evh_261555069697365_deleted_2381],
      }
    );
    const evh_261555069697365_clickPreventStop_2379 = new actions.EventHandlerImpl(
      {
        action: act_261555069697365_rest_2380,
        event: "click.prevent.stop",
        displayName: "deleteItem",
      }
    );
    const evh_261555069697365_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_261555069697365_clickPreventStop_2379],
      }
    );
    const act_2272469684735879_script_2384 = new actions.ScriptAction(
      {
        actionArgs: this.act_2272469684735879_script_2384_getActionArgs,
        events: [],
      }
    );
    const evh_2272469684735879_saved_2383 = new actions.EventHandlerImpl(
      {
        action: act_2272469684735879_script_2384,
        event: "saved",
        displayName: "script",
      }
    );
    const act_2272469684735879_reloadComponentData_2386 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2272469684735879_saved_2385 = new actions.EventHandlerImpl(
      {
        action: act_2272469684735879_reloadComponentData_2386,
        event: "saved",
        displayName: "reloadComponentData",
      }
    );
    const evh_2272469684735879_saved = new actions.EventHandlerGroup(
      {
        handlers: [evh_2272469684735879_saved_2383, evh_2272469684735879_saved_2385],
      }
    );
    const act_2272469684735879_script_2388 = new actions.ScriptAction(
      {
        actionArgs: this.act_2272469684735879_script_2388_getActionArgs,
        events: [],
      }
    );
    const evh_2272469684735879_cancelEdit_2387 = new actions.EventHandlerImpl(
      {
        action: act_2272469684735879_script_2388,
        event: "cancelEdit",
        displayName: "script",
      }
    );
    const evh_2272469684735879_cancelEdit = new actions.EventHandlerGroup(
      {
        handlers: [evh_2272469684735879_cancelEdit_2387],
      }
    );
    const act_3373384577795494_script_2390 = new actions.ScriptAction(
      {
        actionArgs: this.act_3373384577795494_script_2390_getActionArgs,
        displayName: "createRule",
        events: [],
      }
    );
    const evh_3373384577795494_clickPreventStop_2389 = new actions.EventHandlerImpl(
      {
        action: act_3373384577795494_script_2390,
        event: "click.prevent.stop",
        displayName: "createRule",
      }
    );
    const evh_3373384577795494_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3373384577795494_clickPreventStop_2389],
      }
    );
    const act_3601807637515735_script_2392 = new actions.ScriptAction(
      {
        actionArgs: this.act_3601807637515735_script_2392_getActionArgs,
        displayName: "createRule",
        events: [],
      }
    );
    const evh_3601807637515735_clickPreventStop_2391 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_script_2392,
        event: "click.prevent.stop",
        displayName: "createRule",
      }
    );
    const evh_3601807637515735_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3601807637515735_clickPreventStop_2391],
      }
    );
    const act_2140198529698299_closeComponent_2394 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2140198529698299_clickPreventStop_2393 = new actions.EventHandlerImpl(
      {
        action: act_2140198529698299_closeComponent_2394,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2140198529698299_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2140198529698299_clickPreventStop_2393],
      }
    );
    return {
      act_7315092382398562_closeModal_2362,
      evh_7315092382398562_close_2361,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2364,
      evh_2248226175642056_close_2363,
      evh_2248226175642056_close,
      act_6466705138206980_reloadComponentData_2366,
      evh_6466705138206980_clickPreventStop_2365,
      evh_6466705138206980_clickPreventStop,
      act_8320016629450276_reloadComponentData_2370,
      evh_8320016629450276_close_2369,
      act_8320016629450276_showModal_2368,
      evh_8320016629450276_clickPreventStop_2367,
      evh_8320016629450276_clickPreventStop,
      act_5731695935601903_script_2372,
      evh_5731695935601903_saved_2371,
      act_5731695935601903_reloadComponentData_2374,
      evh_5731695935601903_saved_2373,
      evh_5731695935601903_saved,
      act_5731695935601903_script_2376,
      evh_5731695935601903_cancelEdit_2375,
      evh_5731695935601903_cancelEdit,
      act_4196617261796474_script_2378,
      evh_4196617261796474_clickPreventStop_2377,
      evh_4196617261796474_clickPreventStop,
      act_261555069697365_reloadComponentData_2382,
      evh_261555069697365_deleted_2381,
      act_261555069697365_rest_2380,
      evh_261555069697365_clickPreventStop_2379,
      evh_261555069697365_clickPreventStop,
      act_2272469684735879_script_2384,
      evh_2272469684735879_saved_2383,
      act_2272469684735879_reloadComponentData_2386,
      evh_2272469684735879_saved_2385,
      evh_2272469684735879_saved,
      act_2272469684735879_script_2388,
      evh_2272469684735879_cancelEdit_2387,
      evh_2272469684735879_cancelEdit,
      act_3373384577795494_script_2390,
      evh_3373384577795494_clickPreventStop_2389,
      evh_3373384577795494_clickPreventStop,
      act_3601807637515735_script_2392,
      evh_3601807637515735_clickPreventStop_2391,
      evh_3601807637515735_clickPreventStop,
      act_2140198529698299_closeComponent_2394,
      evh_2140198529698299_clickPreventStop_2393,
      evh_2140198529698299_clickPreventStop,
      reload: act_6466705138206980_reloadComponentData_2366,
      editItem: act_4196617261796474_script_2378,
      deleteItem: act_261555069697365_rest_2380,
      createRule: act_3601807637515735_script_2392,
    }
  }
}

Vue.component("BillingRules", BillingRules);

</script>